<template>
  <div
    v-if="loading"
    class="w-full h-full grow flex items-center justify-center "
  >
    <b-spinner
      class="!w-12 !h-12"
      variant="primary"
    />
  </div>
  <b-modal
    v-else-if="hasSubscription"
    visible
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    hide-header
    body-class="py-4"
  >
    <h4
      class="h2 font-weight-bold mb-4 text-center"
    >
      Account Already Active
    </h4>

    <p
      class="mt-4  text-center"
    >
      Your account is already activated and subscribed. <br> 
      No further action needed. <br>
      If you need help, please contact support.
    </p>


    <div class="d-flex align-items-center justify-content-center">
      <a
        href="https://estage.com/member/login"
        class="btn btn-wide btn-primary"
        target="_self"
      > Log In </a>
    </div>
  </b-modal>
  <div
    v-else-if="$route.query.user && !hasSubscription"
    class="bg-[#F4F7FC] overflow-hidden"
  >
    <div class="relative flex items-center justify-center w-full min-h-screen p-[1.25rem] md:p-[2.5rem]">
      <div class="flex flex-col items-center max-w-[600px] w-full mx-auto">
        <img
          class="h-[17px] w-[134.06px] cursor-pointer"
          src="@/assets/icons/main-logo.svg"
          alt="Logo"
        >

        <welcome-step-form
          class="mt-[3.125rem]"
          @activated="activate"
        />

        <footer class="grid grid-flow-row mt-[6rem]">
          <div class="flex items-center justify-center gap-x-[.75rem]">
            <!--            <a-->
            <!--              href="https://estage.com/"-->
            <!--              target="_blank"-->
            <!--              class="text-center text-[.875rem] text-[#ADADAD] leading-[2rem] font-[400] font-[ProximaNova] hover:text-[#ADADAD] hover:underline"-->
            <!--            >-->
            <!--              Terms-->
            <!--            </a>-->
            <!--            <a-->
            <!--              href="https://estage.com/"-->
            <!--              target="_blank"-->
            <!--              class="text-center text-[.875rem] text-[#ADADAD] leading-[2rem] font-[400] font-[ProximaNova] hover:text-[#ADADAD] hover:underline"-->
            <!--            >-->
            <!--              Privacy-->
            <!--            </a>-->
            <a
              href="https://success.estage.com"
              target="_blank"
              class="text-center text-[.875rem] text-[#ADADAD] leading-[2rem] font-[400] font-[ProximaNova] hover:text-[#ADADAD] hover:underline"
            >
              Support
            </a>
          </div>
          <div class="flex items-center justify-center gap-x-[.75rem]">
            <span class="text-center text-[.875rem] text-[#ADADAD] leading-[2rem] font-[400] font-[ProximaNova]">
              © {{ new Date().getFullYear() }} -
              ESTAGE -
              All Rights Reserved.
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
  <div
    v-else-if="$route.query.old && !hasSubscription"
    class="flex py-[60px] bg-[#F7F8F9] overflow-hidden"
  >
    <div
      class="max-w-[1116px] w-full mx-auto bg-white shadow rounded"
    >
      <div class="flex w-full items-center h-[90px] px-[54px] user-select-none">
        <svg
          width="256"
          height="24"
          viewBox="0 0 256 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.803 9.214L45.831 17H43.264L40.017 5.661H42.72L44.709 13.855L46.868 5.661H48.755L50.897 13.855L52.869 5.661H55.589L52.359 17H49.792L47.803 9.214ZM58.4275 5.661H66.4515V7.735H60.8415V10.2H66.3325V12.274H60.8415V14.909H66.4515V17H58.4275V5.661ZM70.0386 5.661H72.4526V14.875H77.2466V17H70.0386V5.661ZM85.5782 17.204C84.4789 17.204 83.4759 16.9603 82.5692 16.473C81.6625 15.9743 80.9429 15.2773 80.4102 14.382C79.8889 13.4867 79.6282 12.4723 79.6282 11.339C79.6282 10.2057 79.8889 9.19133 80.4102 8.296C80.9429 7.40067 81.6625 6.70933 82.5692 6.222C83.4759 5.72333 84.4789 5.474 85.5782 5.474C86.7682 5.474 87.7542 5.73467 88.5362 6.256C89.3182 6.766 89.9415 7.429 90.4062 8.245L88.3322 9.265C88.0829 8.789 87.7089 8.398 87.2102 8.092C86.7229 7.77467 86.1789 7.616 85.5782 7.616C84.9322 7.616 84.3429 7.78033 83.8102 8.109C83.2775 8.42633 82.8582 8.86833 82.5522 9.435C82.2575 10.0017 82.1102 10.6363 82.1102 11.339C82.1102 12.0417 82.2575 12.6763 82.5522 13.243C82.8582 13.8097 83.2775 14.2573 83.8102 14.586C84.3429 14.9033 84.9322 15.062 85.5782 15.062C86.1902 15.062 86.7399 14.909 87.2272 14.603C87.7145 14.297 88.0829 13.9003 88.3322 13.413L90.4062 14.416C89.3295 16.2747 87.7202 17.204 85.5782 17.204ZM92.9991 11.339C92.9991 10.217 93.2541 9.214 93.7641 8.33C94.2741 7.43467 94.9768 6.73767 95.8721 6.239C96.7788 5.729 97.7931 5.474 98.9151 5.474C100.048 5.474 101.063 5.729 101.958 6.239C102.865 6.73767 103.573 7.43467 104.083 8.33C104.593 9.214 104.848 10.217 104.848 11.339C104.848 12.461 104.593 13.4697 104.083 14.365C103.573 15.249 102.865 15.946 101.958 16.456C101.063 16.9547 100.048 17.204 98.9151 17.204C97.7931 17.204 96.7788 16.9547 95.8721 16.456C94.9768 15.946 94.2741 15.249 93.7641 14.365C93.2541 13.4697 92.9991 12.461 92.9991 11.339ZM102.366 11.339C102.366 10.6363 102.224 10.0017 101.941 9.435C101.658 8.86833 101.25 8.42633 100.717 8.109C100.196 7.78033 99.5951 7.616 98.9151 7.616C98.2351 7.616 97.6344 7.78033 97.1131 8.109C96.5918 8.42633 96.1894 8.86833 95.9061 9.435C95.6228 10.0017 95.4811 10.6363 95.4811 11.339C95.4811 12.0417 95.6228 12.6763 95.9061 13.243C96.1894 13.8097 96.5918 14.2573 97.1131 14.586C97.6344 14.9033 98.2351 15.062 98.9151 15.062C99.5951 15.062 100.196 14.9033 100.717 14.586C101.25 14.2573 101.658 13.8097 101.941 13.243C102.224 12.6763 102.366 12.0417 102.366 11.339ZM118.102 8.84L114.906 17H113.852L110.656 8.84V17H108.242V5.661H111.625L114.379 12.733L117.133 5.661H120.533V17H118.102V8.84ZM124.485 5.661H132.509V7.735H126.899V10.2H132.39V12.274H126.899V14.909H132.509V17H124.485V5.661ZM144.764 7.786H141.449V5.661H150.493V7.786H147.195V17H144.764V7.786ZM152.781 11.339C152.781 10.217 153.036 9.214 153.546 8.33C154.056 7.43467 154.759 6.73767 155.654 6.239C156.561 5.729 157.575 5.474 158.697 5.474C159.831 5.474 160.845 5.729 161.74 6.239C162.647 6.73767 163.355 7.43467 163.865 8.33C164.375 9.214 164.63 10.217 164.63 11.339C164.63 12.461 164.375 13.4697 163.865 14.365C163.355 15.249 162.647 15.946 161.74 16.456C160.845 16.9547 159.831 17.204 158.697 17.204C157.575 17.204 156.561 16.9547 155.654 16.456C154.759 15.946 154.056 15.249 153.546 14.365C153.036 13.4697 152.781 12.461 152.781 11.339ZM162.148 11.339C162.148 10.6363 162.007 10.0017 161.723 9.435C161.44 8.86833 161.032 8.42633 160.499 8.109C159.978 7.78033 159.377 7.616 158.697 7.616C158.017 7.616 157.417 7.78033 156.895 8.109C156.374 8.42633 155.972 8.86833 155.688 9.435C155.405 10.0017 155.263 10.6363 155.263 11.339C155.263 12.0417 155.405 12.6763 155.688 13.243C155.972 13.8097 156.374 14.2573 156.895 14.586C157.417 14.9033 158.017 15.062 158.697 15.062C159.377 15.062 159.978 14.9033 160.499 14.586C161.032 14.2573 161.44 13.8097 161.723 13.243C162.007 12.6763 162.148 12.0417 162.148 11.339Z"
            fill="black"
          />
          <path
            d="M174.074 5.661H182.098V7.735H176.488V10.2H181.979V12.274H176.488V14.909H182.098V17H174.074V5.661ZM186.229 13.566C186.66 14.0193 187.181 14.3877 187.793 14.671C188.416 14.9543 189.096 15.096 189.833 15.096C190.456 15.096 190.938 14.9713 191.278 14.722C191.629 14.4727 191.805 14.1723 191.805 13.821C191.805 13.4357 191.618 13.1467 191.244 12.954C190.87 12.75 190.292 12.5573 189.51 12.376C188.626 12.172 187.906 11.968 187.351 11.764C186.796 11.56 186.308 11.2313 185.889 10.778C185.481 10.3133 185.277 9.69 185.277 8.908C185.277 8.27333 185.453 7.69533 185.804 7.174C186.155 6.65267 186.654 6.24467 187.3 5.95C187.957 5.644 188.717 5.491 189.578 5.491C191.38 5.491 192.853 6.018 193.998 7.072L192.655 8.84C192.213 8.432 191.703 8.126 191.125 7.922C190.558 7.70667 189.986 7.599 189.408 7.599C188.875 7.599 188.462 7.70667 188.167 7.922C187.884 8.126 187.742 8.40367 187.742 8.755C187.742 9.10633 187.918 9.367 188.269 9.537C188.62 9.69567 189.198 9.87133 190.003 10.064C190.864 10.2567 191.578 10.4663 192.145 10.693C192.723 10.9083 193.216 11.2483 193.624 11.713C194.043 12.1777 194.253 12.7953 194.253 13.566C194.253 14.654 193.862 15.5323 193.08 16.201C192.309 16.8697 191.187 17.204 189.714 17.204C187.708 17.204 186.104 16.6033 184.903 15.402L186.229 13.566ZM200.08 7.786H196.765V5.661H205.809V7.786H202.511V17H200.08V7.786ZM215.186 15.045H210.12L209.406 17H206.754L211.14 5.661H214.166L218.535 17H215.9L215.186 15.045ZM210.766 12.954H214.523L212.653 7.752L210.766 12.954ZM220.157 11.339C220.157 10.1717 220.423 9.146 220.956 8.262C221.5 7.36667 222.231 6.681 223.149 6.205C224.067 5.71767 225.081 5.474 226.192 5.474C227.291 5.474 228.226 5.70067 228.997 6.154C229.779 6.60733 230.408 7.208 230.884 7.956L228.878 9.044C228.595 8.62467 228.215 8.28467 227.739 8.024C227.274 7.752 226.759 7.616 226.192 7.616C225.512 7.616 224.9 7.78033 224.356 8.109C223.823 8.42633 223.404 8.86833 223.098 9.435C222.792 10.0017 222.639 10.6363 222.639 11.339C222.639 12.0417 222.792 12.6763 223.098 13.243C223.404 13.8097 223.823 14.2573 224.356 14.586C224.9 14.9033 225.512 15.062 226.192 15.062C226.679 15.062 227.138 14.977 227.569 14.807C228.011 14.637 228.368 14.433 228.64 14.195V12.818H225.614V10.744H231.02V15.079C230.419 15.759 229.711 16.286 228.895 16.66C228.09 17.034 227.189 17.221 226.192 17.221C225.081 17.221 224.067 16.9773 223.149 16.49C222.231 16.0027 221.5 15.3113 220.956 14.416C220.423 13.5207 220.157 12.495 220.157 11.339ZM234.636 5.661H242.66V7.735H237.05V10.2H242.541V12.274H237.05V14.909H242.66V17H234.636V5.661ZM245.976 5.661H248.594L248.254 13.311H246.35L245.976 5.661ZM245.942 15.81C245.942 15.436 246.072 15.113 246.333 14.841C246.605 14.569 246.928 14.433 247.302 14.433C247.676 14.433 247.993 14.569 248.254 14.841C248.526 15.113 248.662 15.436 248.662 15.81C248.662 16.1727 248.526 16.49 248.254 16.762C247.993 17.034 247.676 17.17 247.302 17.17C246.928 17.17 246.605 17.034 246.333 16.762C246.072 16.49 245.942 16.1727 245.942 15.81Z"
            fill="#3D82EA"
          />
          <circle
            cx="12"
            cy="12"
            r="12"
            fill="#E1EBF4"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 16.8278H16.2812V16.2167V15.1153H8.69133V12.6981H16.2812V12.0871V10.9857H7V16.8278Z"
            fill="#1F2121"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 8.71238H16.2812V8.10142V7H7V8.71238Z"
            fill="#4F83E3"
          />
        </svg>

        <img
          src="@builder/assets/svg/fp.svg"
          alt="FP logo"
          class="ml-auto mr-[20px]"
        >
        <img
          src="@builder/assets/svg/af.svg"
          alt="AF logo"
        >
      </div>

      <template v-if="!activated">
        <div
          class="bg-[#F7F8F9] px-[68px] h-[452px] grid grid-cols-2 items-center bg-no-repeat bg-right"
          :style="{backgroundImage: `url(${require('@/assets/svg/welcome-rect-bg.svg')})`}"
        >
          <div>
            <div class="text-[24px] mb-[24px]">
              <strong>Activate Your Business Account!</strong> <br>
              As a new member of Affiliate <br> Business System, you get <strong>30-day free <br> access</strong> to
              ESTAGE business account!
            </div>
            <div class="text-[18px] font-[300]">
              Please watch the welcome video and follow the <br> simple onboarding steps below to activate your <br>
              Estage account so we can start building your
              <br> business right away!
            </div>
          </div>

          <div>
            <div style="padding:56.69% 0 0 0;position:relative;">
              <iframe
                src="https://player.vimeo.com/video/877288323?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                title="ABS to ESTAGE Onboarding"
              />
            </div>
          </div>
        </div>

        <welcome-step-form @activated="activate" />
      </template>

      <template v-else>
        <div
          class="bg-[#F7F8F9] px-[68px] h-[452px] relative bg-no-repeat bg-right"
          :style="{backgroundImage: `url(${require('@/assets/svg/welcome-activated-rect-bg.svg')})`}"
        >
          <div class="text-center text-white pt-[70px]">
            <div class="text-[65px] font-[600] mb-[-5px]">
              Congratulations,
            </div>
            <div class="text-[26px]">
              Your Account Has Been Activated!
            </div>
          </div>

          <div class="w-[710px] h-[399px] absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2">
            <iframe
              src="https://player.vimeo.com/video/877305972?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              style="position:absolute;top:0;left:0;width:100%;height:100%;"
              title="ABS to ESTAGE Onboarding"
              class="w-[710px] h-[399px]"
            />
          </div>
        </div>

        <div class="mt-[-25px] welcome-wizard pt-[250px] pb-[66px]">
          <div class="text-center text-[15px] font-[500] mb-[35px]">
            <span class="text-[#C70D0D]">Important</span> - below is your account login details. Please save it as
            you'll need it to login to your application.
          </div>

          <div class="flex items-center w-full flex-column">
            <div class="px-[126px] py-[43px] mb-[44px] rounded border shadow max-w-[649px] w-full flex flex-column gap-[6px]">
              <div
                v-for="(item, index) in items"
                :key="index"
                class="flex w-full text-nowrap items-center gap-[10px]"
              >
                <div class="min-w-[90px]">
                  {{ item.label }}
                </div>
                <div
                  class="h-[40px] bg-[#F2F5FB] relative rounded flex items-center w-full text-[16px] text-black px-[13px]"
                >
                  <div class="text-truncate max-w-[260px]">
                    {{ item.value }}
                  </div>

                  <b-btn
                    v-b-tooltip.top="copied === index ? 'Copied!' : 'Copy'"
                    v-clipboard:copy="item.value"
                    v-clipboard:success="() => onCopy(index)"
                    class="p-0 bg-transparent border-0 absolute top-1/2 -translate-y-1/2 right-[13px]"
                  >
                    <i class="fa fa-clipboard" />
                  </b-btn>
                </div>
              </div>
            </div>

            <div>
              <a
                class="flex items-center justify-center font-bold text-decoration-none relative mx-[65px] mb-[18px] h-[50px] w-[277px] text-white rounded-[3px] hover:opacity-80 p-0 bg-[#4F83E3] bg-primary"
                type="button"
                target="_blank"
                :href="`https://app.estage.com?auth_token=${token}`"
              >
                Login To Dashboard
              </a>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import WelcomeStepForm from '@/components/editor/components/step-form/welcome/WelcomeStepForm.vue'
import {mapState} from 'vuex'

export default {
  name: 'Welcome',
  components: {WelcomeStepForm},
  data () {
    return {
      copied: -1,
      token: null,
      activated: false,
      loading: false,
      hasSubscription: false,
      items: [
        {
          label: 'Login URL:',
          value: 'https://estage.com/member/login'
        },
        {
          label: 'Username:',
          value: ''
        },
        {
          label: 'Password:',
          value: ''
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    anotherUser () {
      return this.user?.hash !== this.$route.query.user
    }
  },
  created () {
    this.$router.replace({name: 'signup'})
  },
  async mounted () {
    document.title = 'ESTAGE Onboarding'
    await this.checkForSubscription()
    this.checkAnotherUser()
  },
  methods: {
    async checkForSubscription (){
      this.loading = true
      axios.get(`api/auth/welcome/check-has-subscription/${this.$route.query.user}`)
        .then(({data}) => {
          this.hasSubscription = data.data
          this.loading = false
        }).catch((err)=>{
          this.loading = false
          console.err(err)
        })
    },
    checkAnotherUser () {
      if (this.anotherUser) {
        return window.location.href = `/abs-welcome?user=${this.user.hash}`
      }
    },
    activate (data) {
      this.activated = true
      this.token = data.access_token
      this.items[1].value = data.email
      this.items[2].value = data.open_password

      window.scrollTo({
        behavior: 'smooth',
        top: 0,
        left: 0
      })
    },
    onCopy (index) {
      this.copied = index

      setTimeout(() => {
        this.copied = -1
      }, 2000)
    }
  }
}
</script>